import { sendToApi } from 'api/client'

export interface GoogleDriveAccessTokenResponse {
  access_token: string
  expires_in: number
}

export interface GoogleDriveSyncState {
  watched_file_ids: string[]
  sync_started_at: string | null
  sync_completed_at: string | null
  status: 'ready' | 'syncing' | 'failed'
  needs_reauth: boolean
}

export const GoogleDriveClient = {
  getAccessToken: async ({ workspaceId, integrationId }: { workspaceId: number; integrationId: number }) => {
    return sendToApi<GoogleDriveAccessTokenResponse>(`/w/${workspaceId}/google_drive/${integrationId}/access_token`)
  },

  show: async ({ workspaceId, integrationId }: { workspaceId: number; integrationId: number }) => {
    return sendToApi<GoogleDriveSyncState>(`/w/${workspaceId}/google_drive/${integrationId}`)
  },

  update: async ({
    workspaceId,
    integrationId,
    watchedFiles,
  }: {
    workspaceId: number
    integrationId: number
    watchedFiles?: string[]
  }) => {
    return sendToApi<{ success: boolean }>(`/w/${workspaceId}/google_drive/${integrationId}`, {
      method: 'PATCH',
      body: {
        watched_file_ids: watchedFiles,
      },
    })
  },

  sync: async ({
    workspaceId,
    integrationId,
    reset = false,
  }: {
    workspaceId: number
    integrationId: number
    reset?: boolean
  }) => {
    return sendToApi<{ success: boolean; message: string }>(`/w/${workspaceId}/google_drive/${integrationId}/sync`, {
      method: 'POST',
      body: { reset },
    })
  },
}
